import { inject } from "vue";

export const ChainOfThoughtContextKey = Symbol("ChainOfThoughtContext");

export function useChainOfThought() {
  const isOpen = inject(ChainOfThoughtContextKey);

  if (!isOpen) {
    throw new Error(
      "useChainOfThought must be used within a <ChainOfThought> component",
    );
  }

  const setIsOpen = (open) => {
    isOpen.value = open;
  };

  return { isOpen, setIsOpen };
}
